import Report from './Report';
export default Report; 



// WEBPACK FOOTER //
// ./src/scenes/Report/index.js